export default __webpack_public_path__ + "static/media/022-fireworks.622f77f3.svg";